import CopyAddress from "./CopyAddress"

export default CopyAddress